import {useContext, useState} from "react";
import {useTranslation} from "react-i18next";
import Button from "../../../../components/Button.jsx";
import {GlobalContext} from "../../../../utils/context/GlobalContextProvider.jsx";
import {ProjectIntegrationsApi} from "../../../../api/authority/generated/index";
import toast from "react-hot-toast";
import {useNavigate} from "react-router-dom";
import {useErrorTranslation} from "../../../../api/utilities/translateErrorMessage.js";
import TextareaWithClipboard from "../../../../components/TextareaWithClipboard.jsx";
import useIntegrationScript from "../IntegrationFormInput/useIntegrationScript.js";
import useAuthorityConfiguration from "../../../../api/utilities/useAuthorityConfiguration.js";
import useHostNameXmlLinksIntegrationState from "../IntegrationFormInput/useHostNameXmlLinksIntegrationState.js";
import HostNameAndXmlLinkList from "../IntegrationFormInput/HostNameAndXmlLinkList.jsx";

function UpgatesIntegrationFormInput({type, label, value, note, onChange}) {

    let [id] = useState((Math.random() + 1).toString(36).substring(7));

    return <div>
        <div className={'flex gap-4'}>
            <label className='w-full my-auto text-left' htmlFor={'upgates-' + id}>
                {label}:
            </label>
        </div>
        <div>
            <input
                type={type}
                id={'upgates-' + id}
                className='w-full form-input'
                value={value}
                onChange={(e) => onChange(e.target.value)}
            />
        </div>
        <div className={'flex gap-4'}>
            <div className={'w-4/12'}></div>
            <div className={'w-8/12'}>{note}</div>
        </div>
    </div>;
}

export default function UpgatesIntegrationForm({project, projectIntegration}) {

    let {t} = useTranslation();
    let {et} = useErrorTranslation();
    let {resetCurrentUserProjects} = useContext(GlobalContext);
    let navigate = useNavigate();

    let authorityConfiguration = useAuthorityConfiguration();

    let integrationScript = useIntegrationScript('upgates', projectIntegration?.id);

    let [integrationSettings, setIntegrationSettings] = useHostNameXmlLinksIntegrationState(projectIntegration);

    let createUpgatesIntegration = () => {
        new ProjectIntegrationsApi(authorityConfiguration)
            .upgatesIntegration({
                projectId: project.id,
                integrationId: projectIntegration?.id ?? null,
                upgatesIntegrationInput: integrationSettings,
            })
            .then(shoptetIntegrationData => {
                navigate(
                    '/project/' + project.id + '/settings/integrations?integrationId=' + shoptetIntegrationData.id
                );
                resetCurrentUserProjects();
                toast.success(projectIntegration === null ? t('created') : t('saved'));
            })
            .catch(e => et(e).then(toast.error));
    };

    // noinspection JSUnresolvedReference
    return (
        <div className={'flex flex-col gap-2'}>
            {projectIntegration !== null && <>
                <div className={'flex flex-col p-2 border-1 border-slate-400 rounded'}>
                    <strong className={'mt-2'}>{t('integration.upgates.script-title')}:</strong>
                    <TextareaWithClipboard
                        value={integrationScript}
                        showButton={true}
                        textareaClasses={'min-h-[158px]'}
                    />
                    <small className={'mt-2'}>{t('integration.eprivacy-warning')}</small>
                </div>
            </>}

            <div className={'min-h-4 max-h-4'}>{/* spacer */}</div>

            <HostNameAndXmlLinkList
                project={project}
                projectIntegration={projectIntegration}
                value={integrationSettings.hostNameAndXmlLinkList}
                onChange={(hostNameAndXmlLinkList) => {
                    setIntegrationSettings((integrationSettings) => {
                        return {...integrationSettings, hostNameAndXmlLinkList: hostNameAndXmlLinkList};
                    });
                }}
            />

            <div className={'min-h-4 max-h-4'}>{/* spacer */}</div>

            <div className={'flex justify-end'}>
                <Button
                    className={'button-primary'}
                    onClick={() => createUpgatesIntegration()}
                    title={t('project.integration-create')}
                >
                    {projectIntegration
                        ? t('project.integration-update')
                        : t('project.integration-create')}
                </Button>
            </div>
        </div>
    );

}
